import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
    getSellerOffers,
    updateSellerOffers,
    getSellerId
} from "../../utils/api";
import { formatDateDDMMYYYY_AMPM } from "../../utils/helpers";
import Pagination from "../common/Pagination";
import { exportToCSV } from "../../utils/exportHelper";

const OffersTable = ({ filters, refreshKey, setOfferEndTime }) => {

    const exportColumns = [
        { key: "grade_name", label: "Grade" },
        { key: "product", label: "Product" },
        { key: "location", label: "Location" },
        { key: "original_price", label: "Price" },
        { key: "qty", label: "Quantity" },
        { key: "whatsapp", label: "Whatsapp" },
        { key: "calls", label: "Calls" },
        { key: "is_availabe", label: "Available" },
        { key: "created_at", label: "Created At" }
    ];

    const pageSize = 10;
    const [offers, setOffers] = useState([]);
    const [changed, setChanged] = useState(false);
    const [loading, setLoading] = useState(true);
    const [activeGrade, setActiveGrade] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const seller = getSellerId();
    useEffect(() => {
        loadOffers();
    }, [filters, refreshKey, page]);

    useEffect(() => {
        setPage(1);
    }, [filters]);

    const formatPrice = (value) => {
        let num = Number(value);

        if (isNaN(num)) return 0;

        if (num > 9999.95) num = 9999.95;
        if (num < 0) num = 0;

        return Math.round(num * 20) / 20; // multiple of 0.05
    };


    const loadOffers = async () => {

        try {

            setLoading(true);
            console.log(filters);

            const res = await getSellerOffers({
                seller_id: seller,
                page_number: page,
                page_size: 10,
                area_id: filters.area?.id || "",
                grade_id: filters.grade?.id || ""
            });

            setTotalPages(res.totalPages || 1);
            setTotalCount(res.totalCount || 0);



            // setOffers(res.data || []);
            const formatted = (res.data || []).map(o => ({
                id: o.id,
                grade_name: o.grade_name,
                product: `${o.process_name} ${o.brand_name} ${o.code_name}`,
                location: o.location,
                qty: Number(o.qty),
                original_price: o.original_price !== null && o.original_price !== undefined
                    ? Number(o.original_price).toFixed(2)
                    : "0.00",
                is_availabe: Number(o.is_availabe),
                whatsapp: o.whatsappRequestCount || 0,
                calls: o.callRequestCount || 0,
                created_at: formatDateDDMMYYYY_AMPM(o.created_at)
            }));

            // ✅ Check if ALL records have is_availabe === 0
            const allUnavailable = (res.data || []).every(
                o => Number(o.is_availabe) === 0
            );

            if (res.data?.length && allUnavailable) {
                setOfferEndTime(null); // 🔥 NO TIMER
            } else if (res.data?.length) {
                setOfferEndTime(res.data[0].offer_end_time);
            } else {
                setOfferEndTime(null);
            }
            setOffers(formatted);
            if (formatted.length) {
                setActiveGrade("ALL");
            }

        } catch (err) {

            console.error("Offer load error", err);

        } finally {

            setLoading(false);

        }

    };

    const handleUpdateOffers = async () => {

        try {

            const payload = offers.map(o => ({
                seller_id: seller,
                offer_id: o.id,
                qty: o.qty,
                original_price: o.original_price,
                price_validity: "24:00:00",
                is_availabe: o.is_availabe
            }));

            await updateSellerOffers(payload);
            toast.success("Offers updated successfully");
            loadOffers();
            setChanged(false);

        } catch (err) {

            console.error("Update error", err);
            toast.error("Failed to update offers");

        }

    };
    const updateField = (id, field, value) => {

        const updated = offers.map(o =>
            o.id === id ? { ...o, [field]: value } : o
        );

        setOffers(updated);
        setChanged(true);
    };
    const groupedOffers = offers.reduce((acc, offer) => {
        if (!acc[offer.grade_name]) {
            acc[offer.grade_name] = [];
        }
        acc[offer.grade_name].push(offer);
        return acc;
    }, {});
    groupedOffers["ALL"] = offers;

    const orderedGroups = {
        ALL: groupedOffers["ALL"],
        ...Object.fromEntries(
            Object.entries(groupedOffers).filter(([k]) => k !== "ALL")
        )
    };

    return (

        <div className="card offers-table">


            <div className="flex justify-between items-center mb-2">
                <h3>My Offers ({totalCount})</h3>

                <button
                    onClick={() =>
                        exportToCSV({
                            data: groupedOffers[activeGrade] || [],
                            columns: exportColumns,
                            fileName: `offers_${activeGrade}_${page}`
                        })
                    }
                    className="px-1 py-1.5 text-sm rounded-md bg-[var(--base-color)] text-white hover:bg-[var(--secondary-color)]"
                >
                    Export CSV
                </button>
            </div>


            <div className="flex flex-wrap gap-2 mb-3 border-b pb-2">

                {Object.entries(orderedGroups).map(([grade, items]) => {
                    const isActive = activeGrade === grade;

                    return (
                        <button
                            key={grade}
                            onClick={() => setActiveGrade(grade)}
                            className={`
                    px-3 py-1.5
                    text-xs sm:text-sm
                    rounded-md
                    transition-all
                    border

                    ${isActive
                                    ? "bg-[#064E8D] text-white border-[#064E8D]"
                                    : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                                }
                `}
                        >
                            {grade} ({items.length})
                        </button>
                    );
                })}

            </div>
            <div className="table-scroll">
                <table>

                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Grade</th>
                            <th>Product</th>
                            <th>Location</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Whatsapp</th>
                            <th>Calls</th>
                            <th>Available</th>
                            <th>Created At</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading && (
                            <tr>
                                <td colSpan="9">Loading offers...</td>
                            </tr>
                        )}

                        {!loading && groupedOffers[activeGrade]?.map((o, i) => (
                            <tr key={o.id} className="hover:bg-gray-50">
                                <td>{(page - 1) * pageSize + i + 1}</td>
                                <td>{o.grade_name}</td>
                                <td>{o.product}</td>
                                <td>{o.location}</td>

                                {/* PRICE */}
                                <td>
                                    <div className="number-input">
                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(
                                                    o.id,
                                                    "original_price",
                                                    formatPrice(Number(o.original_price) - 0.05)
                                                )
                                            }
                                        >
                                            -
                                        </button>

                                        <input
                                            type="text"
                                            value={o.original_price}
                                            onChange={(e) => {
                                                const val = e.target.value;

                                                if (val === "") {
                                                    updateField(o.id, "original_price", "");
                                                    return;
                                                }

                                                if (!/^\d{0,4}(\.\d{0,2})?$/.test(val)) return;

                                                if (/^\d{0,4}\.\d{2}$/.test(val)) {
                                                    updateField(
                                                        o.id,
                                                        "original_price",
                                                        formatPrice(val).toFixed(2)
                                                    );
                                                    return;
                                                }

                                                updateField(o.id, "original_price", val);
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value;

                                                updateField(
                                                    o.id,
                                                    "original_price",
                                                    formatPrice(val).toFixed(2)
                                                );
                                            }}
                                        />

                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(
                                                    o.id,
                                                    "original_price",
                                                    formatPrice(Number(o.original_price) + 0.05)
                                                )
                                            }
                                        >
                                            +
                                        </button>
                                    </div>
                                </td>

                                {/* QTY */}
                                <td>
                                    <div className="number-input">
                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(o.id, "qty", Math.max(0, Number(o.qty) - 1))
                                            }
                                        >
                                            -
                                        </button>

                                        <input
                                            type="number"
                                            value={o.qty}
                                            onChange={(e) =>
                                                updateField(o.id, "qty", Number(e.target.value))
                                            }
                                        />

                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(o.id, "qty", Number(o.qty) + 1)
                                            }
                                        >
                                            +
                                        </button>
                                    </div>
                                </td>

                                <td>{o.whatsapp}</td>
                                <td>{o.calls}</td>

                                {/* SWITCH */}
                                <td>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={o.is_availabe === 1}
                                            onChange={(e) =>
                                                updateField(o.id, "is_availabe", e.target.checked ? 1 : 0)
                                            }
                                        />
                                        <span className="slider"></span>
                                    </label>
                                </td>

                                <td>{o.created_at}</td>
                            </tr>
                        ))}
                    </tbody>

                </table>
                <Pagination
                    page={page}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={(p) => setPage(p)}
                />

            </div>

            {changed && (
                <div className="update-offer-wrapper">
                    <button
                        className="btn-primary update-btn"
                        onClick={handleUpdateOffers}
                    >
                        Save Updated Offers
                    </button>
                </div>
            )}


        </div>
    );
};

export default OffersTable;